import { IVehicle } from "@interfaces/IVehicle";
import { VeriDate } from "@services/veriDate.service";
import * as angular from "angular";
import * as moment from "moment";
import { DataValidationStatus, IVehicleData } from "./IVehicleData";

export class VehicleDataService {

    static $inject = ["$http","veriDate"];

    constructor(private $http: angular.IHttpService, private readonly veriDate: VeriDate) {
    }

    getVehicleData(): angular.IPromise<IVehicleData[]> {
        return this.$http(
            {
                method: "GET",
                url: "/api/vehicledata/"
            })
            .then((response: angular.IHttpPromiseCallbackArg<IVehicleData[]>) => {
                return response.data;
            });
    }

    getDataForVehicle(id: number): angular.IPromise<IVehicleData> {
        return this.$http(
            {
                method: "GET",
                url: `/api/vehicledata/${id}`
            })
            .then((response: angular.IHttpPromiseCallbackArg<IVehicleData>) => {
                return response.data;
            });
    }

    //updateFleetData(): angular.IPromise<void> {
    //    return this.$http(
    //        {
    //            method: "GET",
    //            url: "/api/vehicledata/update"
    //        })
    //        .then(() => {
    //            return;
    //        });
    //}

    findVehicleData(vehicleId: number, vehicleData: IVehicleData[]): IVehicleData {
        for (var i = 0; i < vehicleData.length; i++) {
            const data = vehicleData[i];

            if (data.VehicleId == vehicleId) {
                return data;
            }
        }

        return null;
    }

    calculateMOTAndTaxStatus(vehicle: IVehicle, vehicleData: IVehicleData): any {
        if (!vehicleData) {
            return;
        }

        vehicle.vehicleData = vehicleData;

        var threeWeeksFromNow = moment().add(3, "weeks");

        vehicle.vehicleData.motExpirationStatus = DataValidationStatus.NoDetailsFound;
        vehicle.vehicleData.taxExpirationStatus = DataValidationStatus.NoDetailsFound;

        if (vehicle.vehicleData.MotExpiry) {

            var motExpiryMoment = this.veriDate.createMoment(vehicle.vehicleData.MotExpiry);
            
            if (moment().isAfter(motExpiryMoment)) {
                vehicle.vehicleData.motExpirationStatus = DataValidationStatus.Expired;
            }
            else if (threeWeeksFromNow.isAfter(motExpiryMoment)) {
                vehicle.vehicleData.motExpirationStatus = DataValidationStatus.DueSoon;
            }
            else {
                vehicle.vehicleData.motExpirationStatus = DataValidationStatus.Valid;
            }
        }

        if (vehicle.vehicleData.TaxExpiry) {

            var taxExpiryMoment = this.veriDate.createMoment(vehicle.vehicleData.TaxExpiry);

            if (moment().isAfter(taxExpiryMoment)) {
                vehicle.vehicleData.taxExpirationStatus = DataValidationStatus.Expired;
            }
            else if (threeWeeksFromNow.isAfter(taxExpiryMoment)) {
                vehicle.vehicleData.taxExpirationStatus = DataValidationStatus.DueSoon;
            }
            else {
                vehicle.vehicleData.taxExpirationStatus = DataValidationStatus.Valid;
            }
        }
    }
}
